/* THE FIELD — Custom Theme JS
   Handles: mobile nav toggle, quantity steppers, add-to-cart (AJAX),
   cart quantity updates, product image swap.
*/
document.addEventListener('DOMContentLoaded', function () {

  /* Mobile nav toggle */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-field-nav]');
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  /* Product image swap */
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-full');
      var mainImg = document.querySelector('[data-main-media]');
      if (mainImg && src) { mainImg.setAttribute('src', src); }
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  /* Quantity stepper (product + cart) */
  document.querySelectorAll('[data-qty-wrapper]').forEach(function (wrapper) {
    var input = wrapper.querySelector('input[type="number"]');
    var minus = wrapper.querySelector('[data-qty-minus]');
    var plus = wrapper.querySelector('[data-qty-plus]');
    if (!input) return;
    minus && minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    plus && plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* Variant swatch selection -> hidden select sync */
  document.querySelectorAll('[data-option-group]').forEach(function (group) {
    var swatches = group.querySelectorAll('[data-swatch]');
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.remove('is-selected'); });
        sw.classList.add('is-selected');
        var form = sw.closest('form');
        if (form) { form.dispatchEvent(new CustomEvent('field:option-change')); }
      });
    });
  });

  /* Add to cart via AJAX */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-add-to-cart-btn]');
      var formData = new FormData(form);
      if (btn) { btn.setAttribute('disabled', 'disabled'); btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          if (btn) { btn.textContent = 'Added ✓'; }
          setTimeout(function () {
            if (btn) { btn.removeAttribute('disabled'); btn.textContent = 'Add to Cart'; }
          }, 1600);
        })
        .catch(function () {
          if (btn) { btn.removeAttribute('disabled'); btn.textContent = 'Add to Cart'; }
          window.location.href = '/cart';
        });
    });
  });

  /* Cart line quantity update */
  document.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var key = input.getAttribute('data-line-key');
      var qty = parseInt(input.value, 10) || 1;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { window.location.reload(); });
    });
  });

  /* Cart line remove */
  document.querySelectorAll('[data-cart-remove]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-line-key');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () { window.location.reload(); });
    });
  });

});
